module.exports = "/_next/static/images/LovedBy10MillionDevelopers@2x-621761a64ecb9b1ff0b9a8fda6e9ad4d.webp";